import tw from "twin.macro"
import { CopyBlockProps } from "./StackedImageModule.d"
import { useContext } from "react"
import { DisclaimersContext } from "../../../../contexts/Disclaimers"
import { parseDisclaimerBlocks } from "../../../../helpers"
import { toggleDisclaimersModal } from "../../../../contexts/Disclaimers/actions"

const CopyBlock: React.FC<CopyBlockProps> = ({
  title,
  description,
  firstElement,
  lastElement,
}) => {
  const [disclaimerState, dispatch] = useContext(DisclaimersContext)

  return (
    <div
      css={[
        tw`flex flex-col gap-8`,
        firstElement ? tw`mb-10` : lastElement ? tw`mt-10` : tw`my-10`,
      ]}
    >
      <h2 css={[tw`text-5xl block leading-[104.6%] lg:text-5xl xl:text-5xl`]}>
        {parseDisclaimerBlocks(title, selection =>
          dispatch(toggleDisclaimersModal(selection)),
        )}
      </h2>
      <p css={[tw`max-w-screen-lg text-lg`]}>
        {parseDisclaimerBlocks(description, selection =>
          dispatch(toggleDisclaimersModal(selection)),
        )}
      </p>
    </div>
  )
}

export default CopyBlock
